<script>
  /**
   * 複数の選択肢ボタンから一つを選択できる UI
   */
  import RadioButtons from '../RadioButtons.svelte'

  export let name
  export let label = ''
  export let value = null
  export let options = []
  export let columnSize = null

  $: id = `${name}RadioSelect`

  // オプションを選択されたときのハンドラ
  const selectHandler = option => (value = value !== option ? option : null)
</script>

<div class="field">
  <label class="label" for={id}>{label}</label>
  <div {id} class="control">
    <RadioButtons {name} {options} {columnSize} {selectHandler} bind:value />
  </div>
</div>
